import { render, staticRenderFns } from "./DashboardList.vue?vue&type=template&id=4e9c1dce&scoped=true"
import script from "./DashboardList.vue?vue&type=script&lang=js"
export * from "./DashboardList.vue?vue&type=script&lang=js"
import style0 from "./DashboardList.vue?vue&type=style&index=0&id=4e9c1dce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9c1dce",
  null
  
)

export default component.exports